/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SidedarCompanyItem.vue?vue&type=template&id=7eb25d2e&scoped=true"
import script from "./SidedarCompanyItem.vue?vue&type=script&lang=js"
export * from "./SidedarCompanyItem.vue?vue&type=script&lang=js"
import style0 from "./SidedarCompanyItem.vue?vue&type=style&index=0&id=7eb25d2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb25d2e",
  null
  
)

export default component.exports